import React, { Component } from 'react';
import { Popover, Button, InputNumber, Form } from 'antd';

const FormItem = Form.Item;


export default class Batch extends Component {
    constructor(props) {
        super(props);
        this.staticData = {
            "iPointNum": '所需积分', //所需积分
            "dNewPrice": '换购价', //换购价
            "lTypeNum": '每人限购量', //每人限购量
            "totalQuantity": '总限购量', //总限购量
        }
        this.state = {
            "iPointNum": null,
            "dNewPrice": null, 
            "lTypeNum": null,
            "totalQuantity": null,
        };
    }
    handleConfirmBlur(val, e) {
        if (e.target.value !== '') {
            this.setState({
                [val]: Number(e.target.value)
            })
        }
    }
    handleSave = () => {
        let isEmpty = false;
        Object.values(this.state).forEach(val => {
            if (val !== null && val !== false && val !== true) {
                isEmpty = true
            }
        })
        if (isEmpty) {
            this.props.model.execute('click', this.state)
            this.setState({ visible: false })
        } else {
            cb.utils.alert('请填写需要更改的值', 'warning');
        }
    }
    handleCancle = () => {
        this.setState({ visible: false })
    }
    showPopover = () => {
        this.setState({ visible: true })
    }
    render() {
        const formItemLayout = {
            wrapperCol: { offset: 1 },
            labelCol: { span: 8 },
            wrapperCol: { span: 14 }
        }
        const list = Object.keys(this.staticData).map((val, index) => {
            return (
                <FormItem
                  label={this.staticData[val]}
                  {...formItemLayout}
                  key={index}
                >
                  <InputNumber min={0} placeholder="请输入" size={'default'}  onBlur={this.handleConfirmBlur.bind(this,val)}/>
                </FormItem>
            )
        })

        const content = (
            <Form layout='horizontal' style={{width:'300px'}} className='popover-form'>
                <div className="popover-list">{list}</div>
                <div className="filter-btn-1">
                  <Button type="primary" htmlType="submit" onClick={this.handleSave}>保存</Button>
                  <Button type='default' style={{marginRight:'10px'}} onClick={this.handleCancle}>取消</Button>  
                </div>
            </Form>
        )
        return (
            <Popover content={content} visible={this.state.visible} onClick={this.showPopover} arrowPointAtCenter autoAdjustOverflow={false} trigger='click' placement='left' className='popover-form'>
              {this.props.children}
            </Popover>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/components/popover/BatchSKU.jsx


// WEBPACK FOOTER //
// ./src/common/components/popover/Batch.jsx